<ngx-ui-loader></ngx-ui-loader>

<div class="ui-g">
  <div class="ui-g-12">
    <p-table #dt class="search-results" [columns]="colunas" [value]="osS" responsive="true"
    infiniteScroll
    [infiniteScrollDistance]="2"
    [infiniteScrollThrottle]="5000"
    (scrolled)="onScroll()">

      <ng-template pTemplate="caption">
        <label i18n="@@labelText20">ATENDIMENTOS EM ABERTO</label>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th class="col-header-id">
            <label i18n="@@labelText21">Código</label>
          </th>
          <th>
            <label i18n="@@labelText22">Status</label>
          </th>
          <th>
            <label i18n="@@labelText23">Tipo da Ordem de Serviço</label>
          </th>
          <th>
            <label i18n="@@labelText70">Ativos Requeridos</label>
          </th>
          <th>
            <label i18n="@@labelText24">Endereço</label>
          </th>
          <th>
            <label i18n="@@labelText32">Tecnico (Equipe)</label>
          </th>
          <th>
            <label i18n="@@labelText26">Data Criação</label>
          </th>
          <th>
            <label i18n="@@labelText27">Data Agendada</label>
          </th>
          <th>
            <label i18n="@@labelText72">Observações</label>
          </th>
          <th>
            <label i18n="@@labelText41">Ações</label>
          </th>
        </tr>
        <tr>
          <ng-container *ngIf="qrCodeSearch == false">
          <th *ngFor="let col of columns" [ngSwitch]="col.field">
            <input #code style="width: 100%;" *ngSwitchCase="'codigo'" pInputText type="text" (keyup.enter)="buscarOSPorCodigo(code.value)">
            <p-multiSelect  *ngSwitchCase="'descricaoStatusOS'" [options]="status" defaultLabel="Todos" (onChange)="buscarOSPorStatus($event)"></p-multiSelect>
            <p-multiSelect  *ngSwitchCase="'resumoTipoOSAux'" [options]="tipoOs" defaultLabel="Todas" (onChange)="buscarOSPorTipo($event)"></p-multiSelect>
            <input style="width: 100%;" *ngSwitchCase="'ativosRequeridos'" pInputText type="text" (input)="dt.filter($event.target.value, col.field, col.filterMatchMode)">
            <p-multiSelect *ngSwitchCase="'enderecoCompleto'" [options]="enderecos" defaultLabel="Todos" (onChange)="buscarOSPorEndereco($event)"></p-multiSelect>
            <p-multiSelect *ngSwitchCase="'nome'" [options]="equipes" defaultLabel="Todos" (onChange)="buscarOSPorEquipe($event)"></p-multiSelect>
            <p-calendar (onClearClick)="buscarOSPorDataCriacao(null)" [style]="{'position': 'relative', 'width':'100%'}" [inputStyle]="{'position': 'relative', 'width':'70%'}" showIcon="true" showButtonBar="true" readonlyInput="false" appendTo="body" *ngSwitchCase="'dataCriacao'" dateFormat="dd/mm/yy" dataType="string" (onSelect)="buscarOSPorDataCriacao($event)"></p-calendar>
            <p-calendar (onClearClick)="buscarOSPorDataAgendamento(null)" [style]="{'position': 'relative', 'width':'100%'}" [inputStyle]="{'position': 'relative', 'width':'70%'}" showIcon="true" showButtonBar="true" readonlyInput="false" appendTo="body" *ngSwitchCase="'dataDisponibilidade'" dateFormat="dd/mm/yy" dataType="string" (onSelect)="buscarOSPorDataAgendamento($event)"></p-calendar>
          </th>
          <th *ngIf="qrCodeSearch == false"><button pButton type="button" label="Buscar por QR Code" (click)="displayModal = true"></button></th>
          </ng-container>
          <ng-container *ngIf="qrCodeSearch == true">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th><button pButton type="button" label="Limpar busca" (click)="limparBusca()"></button></th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns" style="word-wrap:break-word">
            {{ rowData[col.field] }}
          </td>

      <td class="col-data" align="center">
            <span class="ui-column-title">Ações</span>
            <label class="iconTable"><a class="fas fa-info-circle fa-lg" (click)="mostrar(rowData)"></a></label>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="Aviso" [(visible)]="displayModal" [style]="{width: '350px', minWidth: '200px'}" [minY]="70">
  <p i18n="@@labelText83">Antes de enviar sua foto, tenha certeza que seu QR Code está centralizado.</p>
  <p-footer>
    <button type="button" pButton icon="pi pi-check" (click)="buscarQRCode()" label="OK"></button>
  </p-footer>
</p-dialog>

